"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHeaderMediaProperty = exports.headerMediaPropertyDefinition = void 0;
exports.headerMediaPropertyDefinition = {
    view: {
        label: 'Header media',
        style: 'media-preview',
    },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'image',
                'video',
                'episode-video',
                'film',
                'recap-video',
                'trailer-video',
                'video-channel',
            ],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'header-media',
};
const isHeaderMediaProperty = (prop) => {
    return prop.name === exports.headerMediaPropertyDefinition.name;
};
exports.isHeaderMediaProperty = isHeaderMediaProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVhZGVyLW1lZGlhLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvaGVhZGVyLW1lZGlhLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGNBQWM7UUFDckIsS0FBSyxFQUFFLGVBQWU7S0FDdkI7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRTtnQkFDUixPQUFPO2dCQUNQLE9BQU87Z0JBQ1AsZUFBZTtnQkFDZixNQUFNO2dCQUNOLGFBQWE7Z0JBQ2IsZUFBZTtnQkFDZixlQUFlO2FBQ2hCO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsY0FBYztDQUNXLENBQUE7QUFJMUIsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLElBQWtCLEVBQStCLEVBQUU7SUFDdkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFDQUE2QixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakMifQ==